import { baseUrl } from '../../network'

export const managePositionsUrl = (companyId: number)=> baseUrl + `/api/company/${companyId}/positions`
export const modifyPositionUrl = (positionId: number)=> baseUrl + `/api/company/positions/${positionId}`
export const getSkillsUrl = ()=> baseUrl + '/api/skills'
